import Vue from 'vue'
import swal from 'sweetalert2'
import axios from 'axios';
import Cookies from 'universal-cookie';
import $ from 'jquery';
import {store} from "../store/store";
import _ from "lodash";


const cookies = new Cookies();
let unauthorizedErrorShown = false;

export default function setup() {
    const _this = this;

    console.log("Vue.prototype.$swal", Vue.prototype);

    axios.interceptors.response.use(function (response) {
        // Do something with response data
        //console.log("response------->",response);
        response.responseTime = new Date().getTime() - response.config.meta.requestStartedAt;
        response.url = response.config.url;

        return response;
    }, async function (error) {
        const locale = Vue.prototype.i18n._vm.locale;
        const messages = Vue.prototype.i18n._vm.$root.messages[locale];
        //console.log("error.response.data ---->", error.response.data);

        let errorMessage = _.get(error, 'response.data.message') || _.get(error, 'response.data.error.briefSummary') || _.get(error, 'response.data.body') || _.get(error, 'response.data.error') || _.get(error, 'response.data.errorKey');

        console.log("errorMessage ----> ", errorMessage);

        if (error.response && error.response.status && error.response.status === 400 && error.config.url.includes("thumbnail") && !axios.isCancel(error)) {
            // skip
        } else if (error.response && error.response.status === 409 && error.response.config.url.includes("ehramba/fileplan") && !axios.isCancel(error)) {
            // skip
        } else if (error.response && error.response.status === 404 && error.response.config.url.includes("content?attachment=false&placeholder=false") && !axios.isCancel(error)) {
            // skip
        } else if (error.response && error.response.status === 500 && error.response.config.url.includes("/content/thumbnails/pdf?c=force") && !axios.isCancel(error)) {
            // skip
        } else if (error.response && error.response.status && error.response.status === 401 && !axios.isCancel(error)) {

            if (unauthorizedErrorShown) {
                return;
            }

            unauthorizedErrorShown = true;

            swal.fire({
                title: messages.text.globals.warningTitle,
                icon: 'warning',
                type: 'warning',
                dangerMode: false,
                html: messages.text.interceptors.accessDeniedSwal.prompt,
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText: messages.text.interceptors.accessDeniedSwal.confirmButtonText,
                cancelButtonText: messages.text.globals.close,
            })
                .then((value) => {
                    if (value.value === true) {
                        window.location.hash = "/prijava";
                        window.location.reload(true);
                        unauthorizedErrorShown = false;
                    } else if (value.dismiss == 'cancel') {
                        unauthorizedErrorShown = false;
                        return false;
                    }
                });

        } else if (!axios.isCancel(error)) {
            if (errorMessage) {
                if (errorMessage.includes('ArcheiaValidationError|')) {
                    errorMessage = errorMessage.split('ArcheiaValidationError|')[1];
                } else if (errorMessage.includes('ArcheiaError|')) {
                    errorMessage = errorMessage.split('ArcheiaError|')[1];
                }
            } else if (/<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i.test(error.response.data) || /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i.test(error.response.data)) {
                let elemDiv = document.createElement('div');
                elemDiv.setAttribute("id", "errorResponse");
                elemDiv.style.cssText = 'position:absolute;width:0px;height:0px;z-index:100;overflow: hidden;';
                elemDiv.innerHTML = error.response.data;
                document.body.appendChild(elemDiv);
                errorMessage = document.body.getElementsByClassName("webscriptErrorMessage")[0] ? document.body.getElementsByClassName("webscriptErrorMessage")[0].innerHTML : 'ArcheiaError|' + document.body.getElementsByTagName('h1')[0].innerText;
                errorMessage = errorMessage ? errorMessage.split('ArcheiaError|')[1] : '';
                if (document.getElementById("errorResponse")) {
                    let elem = document.getElementById("errorResponse");
                    elem.parentNode.removeChild(elem);
                }
            } else {
                errorMessage = messages.text.interceptors.serverCommunicationErrorSwal;
            }

            swal(messages.text.globals.error, errorMessage, "error", {dangerMode: true});

        } else {
            console.log("Axios cancelled request error response");
        }

        // const undefinedNetworkErrorResponse = !error.config.data;

        // if (typeof error.response === 'undefined') {
        //     return false;
        //     console.log("Error has no response status code - TODO: HANDLE THIS!!!");
        //     // window.location.hash = "/prijava";
        //     // window.location.reload(true);
        // }
        //
        // if (error.response.status === 400) {
        //     console.log("----> ", error.response.data);
        //     console.log("---->", error.config.url.includes("archiveExport"))
        //     console.log("error.response.data.message", error.response.data.message);
        //     console.log('error.response.data.message.includes("Label is not ok")', error.response.data.message.includes("Label is not ok"));
        //
        //
        //
        //
        //     if (error.response.data.body && error.response.data.body.validationErrors) {
        //         console.log(error.response.data.body.validationErrors);
        //         console.log("here2");
        //
        //         Vue.$toast.open({
        //             message: messages.text.interceptors.dataNotSavedDueToValidationErrorToast,
        //             type: 'error',
        //             position: 'top-right'
        //         });
        //     } else if(error.config.url.includes("thumbnail")) {
        //         // skip
        //     } else {
        //
        //         if (error.config.url.includes("archiveExport")) {
        //             swal(messages.text.globals.error, messages.text.interceptors.serverCommunicationErrorSwal, "error", {dangerMode: true});
        //         } else if (error.response.data.message.includes("Label is not ok")) {
        //             swal(messages.text.globals.error, messages.text.premikanjeRazredov.errorNewClassNameNotValid, "error", {dangerMode: true});
        //         } else if (error.response.data.message.includes("is duplicated")) {
        //             swal(messages.text.globals.error, messages.text.premikanjeRazredov.errorClassDuplicated, "error", {dangerMode: true});
        //         } else {
        //             swal(messages.text.globals.error, messages.text.interceptors.thisServerCommunicationErrorSwal + (error.response.data.error ?  " " + error.response.data.error + ": " : " ") + error.response.data.message, "error", {dangerMode: true});
        //         }
        //
        //     }
        //
        // } else if (error.response.status === 401) {
        //
        //     if (unauthorizedErrorShown) {
        //         return;
        //     }
        //
        //     unauthorizedErrorShown = true;
        //
        //     swal.fire({
        //         title: messages.text.globals.warningTitle,
        //         icon: 'warning',
        //         type: 'warning',
        //         dangerMode: false,
        //         html: messages.text.interceptors.accessDeniedSwal.prompt,
        //         showCloseButton: true,
        //         showCancelButton: true,
        //         focusConfirm: false,
        //         confirmButtonText: messages.text.interceptors.accessDeniedSwal.confirmButtonText,
        //         cancelButtonText: messages.text.globals.close,
        //     })
        //         .then((value) => {
        //             console.log("value", value);
        //
        //             if (value.value === true) {
        //                 window.location.hash = "/prijava";
        //                 window.location.reload(true);
        //                 unauthorizedErrorShown = false;
        //             } else if (value.dismiss == 'cancel') {
        //                 console.log("CANCEL");
        //                 unauthorizedErrorShown = false;
        //                 return false;
        //             }
        //         });
        //
        // } else if (error.response.status === 404) {
        //     if (error.config.url.includes("/nodes/") && !error.config.url.includes("/doclib/")) {
        //         swal(messages.text.interceptors.documentAccessDeniedSwal.title, messages.text.interceptors.documentAccessDeniedSwal.prompt, "error", {dangerMode: true});
        //     }
        //
        // } else if (error.response.status === 409) {
        //     if (error.config.url.includes("fileplan")) {
        //     } else {
        //         swal(messages.text.globals.error, error.response.data.message, "error", {dangerMode: true});
        //     }
        //
        // } else if (error.response.status === 413) {
        //     swal(messages.text.globals.error, messages.text.interceptors.fileTooBigUploadErrorSwal.prompt, "error", {dangerMode: true});
        //
        // } else if (error.response.status === 500) {
        //
        //     console.log("error config ", error.config);
        //     console.log("---->", error.response.data);
        //
        //     if(error.config.url.includes("/longTermManualUpload")) {
        //         // show custom error message on UploadDocumentLongTermStorageFormat
        //
        //     } else if (error.config.method === 'delete' && error.config.url.includes('sifranti/v1/document-type/')) {
        //         swal(messages.text.globals.error, "Zapisa, na katerega je vezan povezan sistem, ni mogoče brisati. Če želite zapis zbrisati, prvo odstranite podatke o povezanem sistemu!", "error", {dangerMode: true});
        //
        //     } else if (error.config.method === 'post' && error.config.url.includes('api/rma/admin/ehramba/irregularDestroy') && error.response.data.includes('Record has been marked for accession and should not be destroyed')) {
        //         swal(messages.text.globals.error, messages.text.documentDetails.recordMarkedForAccessionCouldNotBeDestroyedErrorMsg, "error", {dangerMode: true});
        //
        //     } else if (typeof error.response.data.error === 'object') {
        //         swal(messages.text.globals.error, messages.text.interceptors.thisServerCommunicationErrorSwal + error.response.data.error.briefSummary, "error", {dangerMode: true});
        //     } else if (/<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i.test(error.response.data) || /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i.test(error.response.data.body)) { // check if error is HTML string
        //         if ((typeof error.response.data === 'string' && error.response.data.indexOf('thumbnails/pdf') > -1) || (error.response.data.body && error.response.data.body.indexOf('thumbnails/pdf') > -1)) {
        //             // Do not show error popup if PDF preview cannot be generated
        //         } else {
        //             if (error.response.data && typeof error.response.data === 'string' && error.response.data.includes("The record does not match criteria for starting the documentReview")){
        //                 // DO NOTHING!
        //             } else {
        //                 swal(messages.text.globals.error, '<div class="htmlError">' + (error.response.data.body ? error.response.data.body : error.response.data) + '</div>', "error", {dangerMode: true});
        //             }
        //         }
        //     } else if (typeof error.response.data.error === 'string') {
        //         swal(messages.text.globals.error, messages.text.interceptors.thisServerCommunicationErrorSwal + error.response.data.error + ": " + error.response.data.message, "error", {dangerMode: true});
        //     } else if (!error.response.data.error && error.response.data.message && typeof error.response.data.message === 'string') {
        //         if (error.response.data.message.includes("One or more of the classes is already scheduled to be edited")) {
        //             swal(messages.text.globals.error, messages.text.premikanjeRazredov.errorClassAlreadyScheduledToBeEdited, "error", {dangerMode: true});
        //         } else {
        //             swal(messages.text.globals.error, messages.text.interceptors.thisServerCommunicationErrorSwal + error.response.data.message, "error", {dangerMode: true});
        //         }
        //
        //     } else if (error.response.data.status === 'ERROR') {
        //         swal(messages.text.globals.error, messages.text.interceptors.thisServerCommunicationErrorSwal + error.response.data.body, "error", {dangerMode: true});
        //     } else {
        //         swal(messages.text.globals.error, messages.text.interceptors.unknownServerErrorSwal, "error", {dangerMode: true});
        //     }
        //
        // } else if (error.response.status === 504) {
        //
        //     swal.fire({
        //         title: messages.text.globals.warningTitle,
        //         icon: 'warning',
        //         type: 'warning',
        //         dangerMode: false,
        //         text: messages.text.interceptors.timeoutErrorMessage,
        //         showCloseButton: true,
        //         showCancelButton: false,
        //         focusConfirm: false,
        //         confirmButtonText: messages.text.globals.ok,
        //     });
        //
        // } else if (error.response.status === 408 && error.config.url.includes("audit")) {
        //     // ignore timeout error and handle it on Audit page!!!
        // } else {
        //     console.log("Uncaught error - redirected to login!");
        //     swal(messages.text.globals.error, messages.text.interceptors.unknownServerCommunicationErrorSwal, "error", {dangerMode: true});
        // }

        // Do something with response error
        return Promise.reject(error);
    });

    axios.interceptors.request.use(_config => {

        //  Generate cancel token source
        let source = axios.CancelToken.source();

        // Set cancel token on this request
        _config.cancelToken = source.token;

        // Add to vuex to make cancellation available from anywhere
        store.commit('ADD_CANCEL_TOKEN', source);

        // to avoid overwriting if another interceptor
        // already defined the same object (meta)
        _config.meta = _config.meta || {}
        _config.meta.requestStartedAt = new Date().getTime();

        if (_config.url.includes('alfrescocache')) {
            let username = 'admin';
            let password = 'admin';
            let basicAuth = 'Basic ' + btoa(username + ':' + password);

            _config.headers.Authorization = basicAuth;
        } else {
            _config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`;
        }

        // globally handle special case for role "ARHIV_RS"
        if (_config.url === config.alfrescoSearchApi) {
            if (!Vue.prototype.$globalFunctions.checkForPermission('DOST_DOK_IN_META') && Vue.prototype.$globalFunctions.checkForPermission('DOST_DOK_ARHIV')) {
                _config.data.query.query += ' AND EH:status_gradiva:3';
            }
        }
        return _config
    }, error => {
        return Promise.reject(error)
    })

}



// WEBPACK FOOTER //
// ./src/helpers/interceptors.js